<template>
  <div class="booking-divider booking-divider-right">
    <div class="booking-content">
      <template v-if="loadingResources">
        <span class="inline-loader d-md-block d-none h-100"></span>
        <span class="inline-loader d-md-none d-block"></span>
      </template>
      <template v-else-if="noResources">
        <display-banner/>
        <div class="font-size-h2 text-header-color mt-3 mt-md-1 px-4 text-center">NO RESOURCES AVAILABLE</div>
      </template>
      <template v-else>
        <div class="my-2 px-2 text-default w-100 text-center">Select a Date & Time</div>
        <date-select/>
        <validation-message v-if="message" :message="message" class="mt-3"/>
        <time-slots-per-resource v-if="useResourceTimeSlotsView"/>
        <time-slots v-else/>
      </template>
    </div>
    <div class="fixed-buttons" v-if="!noResources">
      <button class="btn btn-tertiary w-100 mr-2" @click="back">Back</button>
      <button class="btn btn-secondary w-100 ml-2" @click="next">Next</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ResourceCacheMixin } from '@/mixins/Booking/ResourceCacheMixin'
import { WorkingHourCacheMixin } from '@/mixins/Booking/WorkingHourCacheMixin'
import { SiteBookingResourceOrderSettingCacheMixin } from '@/mixins/Booking/SiteBookingResourceOrderSettingCacheMixin'
import DateSelect from './DateSelect.vue'
import TimeSlots from './TimeSlots.vue'
import TimeSlotsPerResource from './TimeSlotsPerResource.vue'
import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue'
import DisplayBanner from '../DisplayBanner.vue'

export default {
  name: 'DateTimeSelect',
  mixins: [ResourceCacheMixin, WorkingHourCacheMixin, SiteBookingResourceOrderSettingCacheMixin],
  props: {
    resourceTimeSlotsEnabled: {
      default: false
    }
  },
  data () {
    return {
      message: '',
      isValid: false
    }
  },
  computed: {
    ...mapState('BookingUpload', [
      'startUtc',
      'selectedPets'
    ]),
    ...mapState('BookingSelectedDate', [
      'selectedDate'
    ]),
    noResources () {
      return !!this.attemptedResources && this.bookableResources.length < 1 && !this.loadingResources
    },
    useResourceTimeSlotsView () {
      return this.resourceTimeSlotsEnabled && this.selectedPets.length === 1
    }
  },
  watch: {
    selectedDate () {
      this.message = ''
      this.isValid = false
    }
  },
  methods: {
    back () {
      this.$emit('back')
      this.$emit('toLastPet', true)
    },
    next () {
      this.check()
      if (this.isValid) {
        this.$emit('next')
      }
    },
    check () {
      this.isValid = !!this.startUtc
      this.message = this.isValid ? '' : 'Please select a time slot'
    }
  },
  components: {
    'date-select': DateSelect,
    'time-slots': TimeSlots,
    'time-slots-per-resource': TimeSlotsPerResource,
    'validation-message': ValidationMessage,
    'display-banner': DisplayBanner
  }
}
</script>
